import { render } from "./ReceivePayments.vue?vue&type=template&id=f12584ea&scoped=true"
import script from "./ReceivePayments.vue?vue&type=script&lang=js"
export * from "./ReceivePayments.vue?vue&type=script&lang=js"

import "./ReceivePayments.vue?vue&type=style&index=0&id=f12584ea&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/cleanshift_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12584ea"]])

export default __exports__